import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
  name: 'onyxCapitalize',
})
export class OnyxCapitalizePipe implements PipeTransform {
  public transform(value: string): string {
    if (!value) return value;
    return `${value[0].toUpperCase()}${value.slice(1)}`;
  }
}
